import { styled } from "styled-components";

export const Container = styled.div(({ theme }) => {
  return {
    fontSize: 12,
    lineHeight: "17px",
    color: theme.colors.grayDark,
    whiteSpace: "nowrap",
    flexShrink: 0,
  };
});
